export interface IStation {
  id_station?: number;
  id_location: number;
  name: string;
  max_power_kw: number;
  is_active: boolean;
  // Joined fields
  location_name?: string;
  client_name?: string;
  created_at?: string;
  updated_at?: string;
}

export class Station implements IStation {
  id_station?: number;
  id_location: number = 0;
  name: string = '';
  max_power_kw: number = 1000;
  is_active: boolean = true;
  location_name?: string;
  client_name?: string;

  constructor(data?: Partial<IStation>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static fromArray(arr: any[]): Station[] {
    return arr.map(item => new Station(item));
  }
}
